/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Banco } from '../models/banco';
import { ContaCredito } from '../models/conta-credito';
import { Message } from '../models/message';

/**
 * API responsavel pelos dados de conta crédito
 */
@Injectable({
  providedIn: 'root',
})
class ContaCreditoService extends __BaseService {
  static readonly obterBancosPath = '/conta-credito/bancos';
  static readonly obterDadosFinanceirosBancosPath = '/conta-credito/dadosfinanceiros/bancos';
  static readonly obterContasCreditoPath = '/conta-credito';
  static readonly alterarContaCreditoPath = '/conta-credito';
  static readonly salvarContaCreditoPath = '/conta-credito';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera uma listagem dos bancos
   * @return Operacao realizada com sucesso
   */
  obterBancosResponse(): __Observable<__StrictHttpResponse<Array<Banco>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/conta-credito/bancos`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Banco>>;
      })
    );
  }
  /**
   * Recupera uma listagem dos bancos
   * @return Operacao realizada com sucesso
   */
  obterBancos(): __Observable<Array<Banco>> {
    return this.obterBancosResponse().pipe(
      __map(_r => _r.body as Array<Banco>)
    );
  }

  /**
   * Recupera uma listagem dos bancos
   * @return Operacao realizada com sucesso
   */
  obterDadosFinanceirosBancosResponse(): __Observable<__StrictHttpResponse<Array<Banco>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/conta-credito/dadosfinanceiros/bancos`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Banco>>;
      })
    );
  }
  /**
   * Recupera uma listagem dos bancos
   * @return Operacao realizada com sucesso
   */
  obterDadosFinanceirosBancos(): __Observable<Array<Banco>> {
    return this.obterDadosFinanceirosBancosResponse().pipe(
      __map(_r => _r.body as Array<Banco>)
    );
  }

  /**
   * Recupera uma listagem das contas credito
   * @return Operacao realizada com sucesso
   */
  obterContasCreditoResponse(): __Observable<__StrictHttpResponse<Array<ContaCredito>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/conta-credito`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ContaCredito>>;
      })
    );
  }
  /**
   * Recupera uma listagem das contas credito
   * @return Operacao realizada com sucesso
   */
  obterContasCredito(): __Observable<Array<ContaCredito>> {
    return this.obterContasCreditoResponse().pipe(
      __map(_r => _r.body as Array<ContaCredito>)
    );
  }

  /**
   * Altera ContaCredito
   * @param ContaCredito Objeto do ContaCredito
   * @return Operacao realizada com sucesso
   */
  alterarContaCreditoResponse(ContaCredito: ContaCredito): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ContaCredito;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/conta-credito`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Altera ContaCredito
   * @param ContaCredito Objeto do ContaCredito
   * @return Operacao realizada com sucesso
   */
  alterarContaCredito(ContaCredito: ContaCredito): __Observable<Message> {
    return this.alterarContaCreditoResponse(ContaCredito).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Cadastra uma ContaCredito
   * @param contaCredito Objeto do ContaCredito
   * @return Operacao realizada com sucesso
   */
  salvarContaCreditoResponse(contaCredito: ContaCredito): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = contaCredito;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/conta-credito`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Cadastra uma ContaCredito
   * @param contaCredito Objeto do ContaCredito
   * @return Operacao realizada com sucesso
   */
  salvarContaCredito(contaCredito: ContaCredito): __Observable<Message> {
    return this.salvarContaCreditoResponse(contaCredito).pipe(
      __map(_r => _r.body as Message)
    );
  }
}

module ContaCreditoService {
}

export { ContaCreditoService }
